import { render, staticRenderFns } from "./GruposLocais.vue?vue&type=template&id=1ba5d31e&scoped=true&"
import script from "./GruposLocais.vue?vue&type=script&lang=js&"
export * from "./GruposLocais.vue?vue&type=script&lang=js&"
import style0 from "./GruposLocais.vue?vue&type=style&index=0&id=1ba5d31e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba5d31e",
  null
  
)

export default component.exports